import type { GateMessageKey } from './gate.en'

/** F4 gate phone strings (Hindi), spread into hi.ts. The type forces every key in gate.en.ts. */
export const gateHi: Record<GateMessageKey, string> = {
  'gate.change': 'बदलें',
  'gate.saveFailed': 'फ़ोन में सेव नहीं हो सका',

  'gate.field.village': 'गाँव',
  'gate.field.date': 'तारीख़',
  'gate.field.scale': 'तराज़ू',
  'gate.field.testWeight': 'टेस्ट बाट',
  'gate.field.scaleShows': 'तराज़ू पर वज़न',
  'gate.field.rateCard': 'रेट कार्ड',
  'gate.field.crop': 'फ़सल',
  'gate.field.field': 'खेत',
  'gate.field.broughtBy': 'कौन लाया',

  'gate.roster.update': 'किसान सूची अपडेट करें',
  'gate.roster.updated': 'किसान सूची अपडेट हो गई',
  'gate.roster.needsNetwork': 'नेटवर्क चाहिए। एक दिन पहले, जहाँ सिग्नल हो, अपडेट करें।',
  'gate.roster.stale': 'किसान सूची 24 घंटे से पुरानी है। उसके बाद जुड़े किसान इसमें नहीं हैं।',

  'gate.day.title': 'संग्रह दिवस',
  'gate.day.hint': 'दिन की स्थिति, हाथ में टैग, अतिरिक्त रोल',
  'gate.day.noneOpen': 'इस फ़ोन पर कोई संग्रह दिवस खुला नहीं है।',
  'gate.day.lastClosed': 'पिछला दिन {code} {when} बंद हुआ',
  'gate.day.open': 'दिन खुला है',
  'gate.day.statusOpen': 'खुला',
  'gate.day.operator': 'ऑपरेटर',
  'gate.day.opened': 'खुलने का समय',
  'gate.day.stampRed': 'मुहर',
  'gate.day.tagsLeft': 'बचे टैग',
  'gate.day.sealsLeft': 'बची सील',
  'gate.day.leftOf': '{total} में से {left}',
  'gate.day.lots': 'लॉट (अच्छे + लाल टाई)',
  'gate.day.lotsHint': 'इस फ़ोन पर कोई राशि नहीं',
  'gate.day.produce': 'आज का माल',
  'gate.day.draftOpen': 'डिलीवरी चल रही है: {name}',
  'gate.day.resume': 'जारी रखें',
  'gate.day.deliveries': 'डिलीवरी ({count})',
  'gate.day.spare': 'अतिरिक्त रोल खोलें',
  'gate.day.voidTag': 'टैग रद्द करें',

  'gate.open.openDay': 'दिन शुरू करें',
  'gate.open.opened': 'दिन शुरू हो गया',
  'gate.open.blockedTitle': 'पिछले दिन का हिसाब नहीं मिला',
  'gate.open.blocked': 'सुपरवाइज़र के कंसोल में ठीक करने तक फ़ोन नया दिन नहीं खोलेगा।',
  'gate.open.noCard': 'किसान सूची और रेट कार्ड अपडेट करें: फ़ोन पर कोई भाव नहीं है।',
  'gate.open.pickScale': 'तराज़ू चुनें।',
  'gate.open.typeTest': 'टेस्ट बाट रखकर तराज़ू पर जो वज़न दिखे, लिखें।',
  'gate.open.testOff': 'तराज़ू {diff} गलत है। समतल करके फिर देखें, या दूसरा तराज़ू लें।',
  'gate.open.testOffShort': '0.100 किलो से ज़्यादा फ़र्क — दिन नहीं खुलेगा।',
  'gate.open.needRoll': 'अपने रोल का पहला और आख़िरी टैग स्कैन करें।',
  'gate.open.needSeals': 'अपनी सील पट्टी की पहली और आख़िरी सील स्कैन करें।',
  'gate.open.stampDue': 'मुहर {date} तक',
  'gate.open.noStamp': 'मुहर की तारीख़ नहीं',
  'gate.open.stampPassed': 'मुहर की तारीख़ निकल गई: दिन खुलेगा, सुपरवाइज़र को बताया जाएगा।',
  'gate.open.notRegistered': 'रजिस्टर नहीं',
  'gate.open.unregisteredWarn': 'अक्टूबर में बिना रजिस्टर तराज़ू चल सकता है, पर रिपोर्ट होगा।',

  'gate.roll.tagRoll': 'टैग रोल',
  'gate.roll.sealStrip': 'सील पट्टी',
  'gate.roll.tag': 'टैग',
  'gate.roll.seal': 'सील',
  'gate.roll.firstTag': 'पहला टैग',
  'gate.roll.lastTag': 'आख़िरी टैग',
  'gate.roll.firstSeal': 'पहली सील',
  'gate.roll.lastSeal': 'आख़िरी सील',
  'gate.roll.confirmRoll': 'रोल पक्का करें',
  'gate.roll.confirmSeals': 'सील पक्की करें',
  'gate.roll.tagsInHand': 'हाथ में {count} टैग',
  'gate.roll.sealsInHand': 'हाथ में {count} सील',
  'gate.roll.unknown': 'यह इस गाँव का रोल नहीं है।',
  'gate.roll.wrongKind': 'गलत प्रकार: सील को टैग की जगह, या टैग को सील की जगह स्कैन किया।',
  'gate.roll.different': 'पहला और आख़िरी अलग-अलग रोल से हैं।',
  'gate.roll.order': 'आख़िरी नंबर पहले नंबर से छोटा है।',
  'gate.roll.notAssigned':
    'यह रोल आपको नहीं दिया गया। ऑफ़िस देगा, या सुपरवाइज़र अपने पिन से दे सकता है।',

  'gate.sup.title': 'सुपरवाइज़र पिन',
  'gate.sup.who': 'कौन सा सुपरवाइज़र?',
  'gate.sup.none': 'इस फ़ोन पर पिन वाला कोई सुपरवाइज़र नहीं। किसान सूची अपडेट करें।',
  'gate.sup.assignRoll': 'यह रोल अभी ऑपरेटर को दें।',
  'gate.sup.assignButton': 'सुपरवाइज़र दे',

  'gate.refuse.unknown': 'आपके रोल का नहीं। सुपरवाइज़र के लिए अलग रखें, अगला लें।',
  'gate.refuse.wrongKind': 'गलत प्रकार: सील बोरी का टैग नहीं है (और उल्टा भी)।',
  'gate.refuse.notConfirmed': 'यह रोल आज पक्का नहीं हुआ। पहले इसे अतिरिक्त रोल की तरह खोलें।',
  'gate.refuse.void': 'यह कोड रद्द हो चुका है। कभी काम नहीं आएगा।',
  'gate.refuse.used': 'यह कोड पहले से किसी और बोरी या नमूने पर है।',
  'gate.refuse.duplicate': 'इस डिलीवरी की एक बोरी पर पहले ही स्कैन हो चुका।',

  'gate.delivery.noDay': 'पहले संग्रह दिवस शुरू करें।',
  'gate.delivery.staleDraft': 'बंद दिन की डिलीवरी {code} अभी फ़ोन पर है। सुपरवाइज़र को बुलाएँ।',
  'gate.step.details': 'डिलीवरी की जानकारी',
  'gate.step.check': 'बोरी जाँच',
  'gate.step.moisture': 'नमी जाँच',
  'gate.step.price': 'भाव',
  'gate.step.tag': 'टैग और वज़न',
  'gate.step.sample': 'नमूना सील करें',
  'gate.step.slip': 'आपका हिसाब और पर्ची',
  'gate.step.close': 'डिलीवरी बंद करें',

  'gate.farmer.title': 'किसान खोजें',
  'gate.farmer.name': 'नाम',
  'gate.farmer.nameHint': 'पहले अक्षर, हिंदी या अंग्रेज़ी',
  'gate.farmer.rosterNo': 'सूची नंबर',
  'gate.farmer.last4': 'फ़ोन के आख़िरी 4 अंक',
  'gate.farmer.last4Hint': 'उनसे फ़ोन के आख़िरी 4 अंक पूछें।',
  'gate.farmer.careOf': 'पिता {name}',
  'gate.farmer.noPhone': 'फ़ोन नंबर दर्ज नहीं: सिर्फ़ फोटो मिलाएँ।',
  'gate.farmer.noPhoneShort': 'फ़ोन नहीं',
  'gate.farmer.phoneMismatch': 'अंक नहीं मिले। फोटो मिलने पर ही आगे बढ़ें; यह गिना जाएगा।',
  'gate.farmer.notOnList': 'सूची में नहीं। डिलीवरी शुरू न करें; सुपरवाइज़र को बुलाएँ।',
  'gate.farmer.isThisHim': 'क्या यही हैं?',
  'gate.farmer.yes': 'हाँ, यही हैं',
  'gate.farmer.no': 'नहीं, फिर खोजें',

  'gate.details.noCrops': 'कोई फ़सल दर्ज नहीं',
  'gate.details.area': 'रकबा {area}',
  'gate.details.anotherField': 'दूसरा खेत (दर्ज नहीं)',
  'gate.details.anotherFieldWarn': 'पूरी डिलीवरी साधारण होगी: ब्रांड के नाम से कभी नहीं बिकेगी।',
  'gate.details.himself': 'ख़ुद',
  'gate.details.someoneElse': 'कोई और',
  'gate.details.delivererName': 'लाने वाले का नाम',
  'gate.details.delivererPhone': 'लाने वाले का फ़ोन',
  'gate.details.delivererPhoto': 'लाने वाले की फोटो',
  'gate.details.tenDigits': '10 अंक',
  'gate.storage.q1': 'घर पर 7 दिन से ज़्यादा रखा?',
  'gate.storage.q2': 'कोई गोली या पाउडर डाला?',
  'gate.storage.riskNote': 'आगे बढ़ें। अच्छी बोरियों का लॉट जाँच के लिए रुकेगा; भाव नहीं बदलेगा।',
  'gate.answer.YES': 'हाँ',
  'gate.answer.NO': 'नहीं',
  'gate.answer.DONT_KNOW': 'पता नहीं',
  'gate.season.label': 'सीज़न बत्ती',
  'gate.season.green': 'हरी',
  'gate.season.amber': 'पीली: भुगतान ऑफ़िस की जाँच के बाद',

  'gate.check.brought': 'कुल बोरियाँ',
  'gate.check.broughtHint': 'कोई बोरी खोलने से पहले सब गिनें।',
  'gate.check.belowTagged': '{count} {count:बोरी|बोरियों} पर टैग लग चुका है।',
  'gate.check.confirmMany': 'हाँ, {count} {count:बोरी|बोरियाँ}',
  'gate.check.failedBags': 'फेल बोरियाँ (लाल टाई)',
  'gate.check.failedN': 'फेल बोरी {n}',
  'gate.check.reason': 'लाल रेखा का कारण',
  'gate.check.photo': 'अंदर की फोटो',
  'gate.check.photoHint': 'हर फेल बोरी के लिए ज़रूरी।',
  'gate.check.addFailed': '+ फेल बोरी',
  'gate.check.removeFailed': 'फेल बोरी हटाएँ',
  'gate.check.redTie': 'हर फेल बोरी पर लाल टाई बाँधें। ये दूसरे, साधारण लॉट में जाएँगी।',
  'gate.check.goodBags': 'अच्छी बोरियाँ',
  'gate.check.failedCount': 'लाल टाई बोरियाँ',
  'gate.check.allFailed': 'सब बोरियाँ फेल: एक साधारण लॉट, नमूना नहीं।',
  'gate.check.moistureBags': 'नमी के लिए बोरी',
  'gate.check.bagPair': 'बोरी {a} और बोरी {b}',
  'gate.check.bagOne': 'बोरी {a} (दो बार)',
  'gate.check.probe': 'सैंपल ड्रॉ',
  'gate.check.probeDone': 'हर अच्छी बोरी के बीच से प्रोब ड्रॉ नमूने की थैली में है।',
  'gate.check.probeUndo': 'वापस लें',
  'gate.check.storage': 'भंडारण के जवाब',
  'gate.check.bagsCounted': 'बोरियाँ गिनीं',
  'gate.check.failedBagsOk': 'हर फेल बोरी का कारण और फोटो',
  'gate.check.probeOk': 'प्रोब ड्रॉ नमूने में',
  'gate.check.accepted': 'भाव स्वीकार',
  'gate.check.tags': '{lot} में टैग = बोरी: {bags} में से {tagged}',
  'gate.check.weights': 'हर बोरी का प्रकार और वज़न',
  'gate.check.moisture': 'नमी पढ़ी',
  'gate.check.sample': 'नमूना सील, तौला (कम से कम {min} ग्राम) और फोटो',
  'gate.check.disputes': 'हर असहमति का नतीजा',
  'gate.check.agreed': 'किसान सहमत (या असहमति के साथ बंद)',
  'gate.check.slipNo': 'पर्ची नंबर',
  'gate.check.slipPhoto': 'पर्ची की फोटो',

  'gate.moisture.required':
    'मूँगफली: रीडिंग ज़रूरी। बिना रीडिंग सिर्फ़ सुपरवाइज़र बंद करवा सकता है।',
  'gate.moisture.optional': 'इस फ़सल के लिए ज़रूरी नहीं।',
  'gate.moisture.meter': 'मीटर',
  'gate.moisture.calStale': 'कैलिब्रेशन बाकी',
  'gate.moisture.readingN': 'रीडिंग {n}',
  'gate.moisture.fromBag': 'बोरी {n} से',
  'gate.moisture.thirdHint': 'किसी और अच्छी बोरी से',
  'gate.moisture.retype': 'फिर लिखें: 3.0 से 40.0 %',
  'gate.moisture.needThird': 'रीडिंग में 1.5 से ज़्यादा फ़र्क: तीसरी रीडिंग लें।',
  'gate.moisture.figure': 'नमी',
  'gate.moisture.dryFirst': 'भंडारण से पहले सुखाएँ। भाव वही।',
  'gate.moisture.noMeter': 'आज मीटर नहीं',
  'gate.moisture.noMeterSaved': 'आज मीटर नहीं: नमी नहीं पढ़ी।',
  'gate.moisture.supAllows': 'सुपरवाइज़र अनुमति (बिना रीडिंग)',
  'gate.moisture.supReason': 'यह मूँगफली लॉट बिना नमी रीडिंग बंद करने दें। लॉट रुकेगा।',
  'gate.moisture.skipped': 'सुपरवाइज़र ने बिना रीडिंग अनुमति दी: लॉट रुकेगा।',
  'gate.moisture.farmerPicked': 'किसान ने चुनी',

  'gate.price.moisture': 'नमी',
  'gate.price.notRead': 'नहीं पढ़ी',
  'gate.price.version': 'कार्ड संस्करण {v}',
  'gate.price.deduction': 'कटौती',
  'gate.price.none': 'इस सीज़न कोई नहीं',
  'gate.price.paidOnProduce': 'भुगतान बोरी के बिना माल के वज़न पर। इस सीज़न नमी से भाव नहीं बदलता।',
  'gate.price.noCard': '{lot} के लिए फ़ोन पर कोई रेट कार्ड नहीं। फ़ोन अपडेट करें।',
  'gate.price.cardHasDeductions':
    '{lot} के कार्ड में कटौती है: फ़ोन इसे नहीं लेगा। ऑफ़िस को फ़ोन करें।',
  'gate.price.hasDeductions': 'कटौती वाला',
  'gate.price.accept': 'स्वीकार',
  'gate.price.divert': 'सुखाकर लाएँगे',
  'gate.divert.title': 'सुखाने के लिए वापस',
  'gate.divert.choice': 'किसान का फ़ैसला',
  'gate.divert.sell': 'आज बेचें',
  'gate.divert.dry': 'घर पर सुखाएँ',
  'gate.divert.reason': 'कारण',
  'gate.divert.tagsUsed': 'टैग लगे',
  'gate.divert.tagsFirst': 'बोरी पर टैग लग चुका है: डिलीवरी रद्द करें और हर टैग रद्द स्कैन करें।',
  'gate.divert.card': 'उन्हें "घर पर कैसे सुखाएँ" कार्ड और बिना टैग की बोरियाँ लौटाएँ।',
  'gate.divert.void': 'ड्राफ्ट रद्द करें',
  'gate.divert.back': 'वापस (आज बेचें)',

  'gate.lot.good': 'अच्छी',
  'gate.lot.red': 'लाल टाई',
  'gate.lot.goodBags': 'अच्छी बोरियाँ: {count}',
  'gate.lot.redBags': 'लाल टाई बोरियाँ: {count}',
  'gate.lot.goodBagsShort': 'अच्छी बोरियाँ',
  'gate.lot.redBagsShort': 'लाल टाई बोरियाँ',
  'gate.tag.runningTotal': 'अब तक माल (इस लॉट में)',
  'gate.tag.allDone': 'हर बोरी पर टैग और वज़न हो गया',
  'gate.tag.bagNofM': '{of} में से बोरी {n}',
  'gate.tag.redPhase': 'अब लाल टाई बोरियाँ।',
  'gate.tag.typed': 'टाइप किया',
  'gate.tag.scanTag': 'टैग स्कैन करें',
  'gate.tag.sackType': 'बोरी का प्रकार',
  'gate.tag.weight': 'वज़न (किलो)',
  'gate.tag.weightHint': 'तराज़ू पर जैसा दिखे, बोरी समेत।',
  'gate.tag.newWeight': 'नया वज़न (किलो)',
  'gate.tag.produce': 'माल का वज़न',
  'gate.tag.saveNext': 'सेव, अगली बोरी',
  'gate.tag.fixLast': 'पिछली ठीक करें',
  'gate.tag.fixNote': 'दोनों वज़न रखे जाते हैं; नया गिना जाएगा।',
  'gate.tag.voidTag': 'टैग रद्द करें',
  'gate.tag.bagsDone': 'हो चुकी बोरियाँ',
  'gate.tag.reweighed': 'दोबारा तौली',
  'gate.tag.moreBags': '{count} {count:बोरी|बोरियाँ} बाकी',
  'gate.tag.twoDecimals': 'तराज़ू जैसा, दशमलव के बाद 2 अंक तक।',
  'gate.tag.typeAgain': '5 से कम या 60 किलो से ज़्यादा: फिर से लिखें।',
  'gate.tag.notSame': 'पहली बार जैसा नहीं है।',
  'gate.tag.reason': 'क्यों',
  'gate.tag.scanToVoid': 'रद्द करने के लिए टैग स्कैन करें',
  'gate.tag.notYours': 'इस डिलीवरी या आपके रोल का टैग नहीं।',
  'gate.tag.keepCut': 'कटा टैग शाम की गिनती के लिए रखें।',
  'gate.tag.voided': '{code} रद्द',

  'gate.sample.seal': 'सील',
  'gate.sample.scanSeal': 'सील स्कैन करें',
  'gate.sample.weight': 'नमूने का वज़न (ग्राम)',
  'gate.sample.min': 'इस फ़सल के लिए कम से कम {g} ग्राम',
  'gate.sample.under': '{g} ग्राम से कम',
  'gate.sample.moreDraws': 'उनकी अच्छी बोरियों से और प्रोब ड्रॉ लें।',
  'gate.sample.confirmBig': 'हाँ, {g} ग्राम',
  'gate.sample.photo': 'फोटो',
  'gate.sample.photoHint': 'सील नंबर और उनकी टैग लगी बोरियाँ एक फोटो में।',
  'gate.sample.supAllows': 'सुपरवाइज़र अनुमति (कम वज़न)',
  'gate.sample.supReason': '{g} ग्राम का नमूना (कम से कम {min} ग्राम) मानें। रिपोर्ट होगा।',
  'gate.sample.voidSeal': 'सील रद्द करें',
  'gate.sample.grams': '{g} ग्राम',
  'gate.sample.allowed': 'अनुमति',

  'gate.slip.bags': 'बोरियाँ',
  'gate.slip.weighed': 'तौला गया वज़न',
  'gate.slip.sacks': 'बोरी का वज़न',
  'gate.slip.produce': 'माल का वज़न',
  'gate.slip.deducted': 'कटौती',
  'gate.slip.payable': 'भुगतान योग्य वज़न',
  'gate.slip.price': 'भाव',
  'gate.slip.value': 'राशि',
  'gate.slip.total': 'कुल राशि',
  'gate.slip.advance':
    'आपका कोई अग्रिम बाकी हो तो ऑफ़िस इसी भुगतान से काटेगा; एसएमएस में भेजी गई राशि होगी।',
  'gate.slip.toBeSent': 'आपके बैंक में भेजा जाएगा; एसएमएस से पक्का होगा।',
  'gate.slip.toBeSentHeld': 'भुगतान सुपरवाइज़र की जाँच के बाद; एसएमएस से पक्का होगा।',
  'gate.slip.account': 'खाता',
  'gate.slip.verified': 'जाँचा हुआ',
  'gate.slip.noAccount': 'कोई जाँचा खाता नहीं: भुगतान अपने आप नहीं जाएगा; ऑफ़िस फ़ोन करेगा।',
  'gate.slip.isAccountHis': 'क्या यह खाता उनका है?',
  'gate.slip.accountNotHis': 'आगे बढ़ें। भुगतान अपने आप नहीं जाएगा; ऑफ़िस उनसे बात करेगा।',
  'gate.slip.agrees': 'किसान सहमत',
  'gate.slip.disagrees': 'किसान असहमत',
  'gate.slip.whatDisputed': 'उन्हें किस पर असहमति है?',
  'gate.slip.copyInOrder':
    'अगली कार्बन पर्ची पर इसी क्रम में लिखें, भंडारण के जवाब पर निशान लगाएँ, कॉपी पर अंगूठा लगवाएँ।',
  'gate.slip.slipNo': 'पर्ची नंबर',
  'gate.slip.slipUsed': 'यह पर्ची नंबर आज पहले लग चुका। फिर लिखें।',
  'gate.slip.photo': 'पर्ची की फोटो',
  'gate.slip.photoHint': 'अंगूठे वाली कार्बन कॉपी।',

  'gate.close.fix': 'ठीक करें',
  'gate.close.amberWaits': 'उन्हें बताएँ कि भुगतान ऑफ़िस की जाँच के बाद होगा।',
  'gate.close.disputedHeld': 'असहमति के साथ बंद: भुगतान सुपरवाइज़र के लिए रुका।',
  'gate.close.row': 'कतार',
  'gate.close.rowOne': 'उनकी {n} {n:बोरी|बोरियाँ} अलग कतार में रखें।',
  'gate.close.rowBoth':
    'उनकी {good} अच्छी {good:बोरी|बोरियाँ} अलग कतार में; {red} लाल टाई {red:बोरी|बोरियाँ} दूसरी कतार में।',
  'gate.close.close': 'डिलीवरी बंद करें',
  'gate.close.done': 'डिलीवरी बंद हुई',
  'gate.close.nextFarmer': 'अगला किसान',
  'gate.cancel.button': 'डिलीवरी रद्द करें',
  'gate.cancel.title': 'डिलीवरी रद्द करें',
  'gate.cancel.explain': 'कुछ नहीं ख़रीदा जाएगा। बोरी पर लगा हर टैग और सील काटकर रद्द स्कैन करें।',
  'gate.cancel.walkAway': 'चले गए / माल वापस ले गए',
  'gate.cancel.diverted': 'सुखाने घर ले गए',
  'gate.cancel.movedToPaper': 'कागज़ पर पूरा किया (टैग बोरी पर रहेंगे)',
  'gate.cancel.scanEach': '{count} कोड काटकर रद्द स्कैन करें।',
  'gate.cancel.ready': 'रद्द करने के लिए तैयार।',
  'gate.cancel.scanVoid': 'कटा टैग स्कैन करें',
  'gate.cancel.notOnList': 'इस डिलीवरी का टैग नहीं।',
  'gate.cancel.send': 'डिलीवरी रद्द करें',
  'gate.cancel.keep': 'डिलीवरी पर वापस',
  'gate.cancel.done': 'डिलीवरी रद्द हुई',

  'gate.dispute.button': 'असहमति',
  'gate.dispute.title': 'असहमति',
  'gate.dispute.aboutLabel': 'किस पर',
  'gate.dispute.about.WEIGHT': 'वज़न',
  'gate.dispute.about.GRADE': 'लाल रेखा',
  'gate.dispute.about.MOISTURE': 'नमी',
  'gate.dispute.whichBag': 'कौन सी बोरी',
  'gate.dispute.whichFailed': 'कौन सी फेल बोरी',
  'gate.dispute.reason': 'कारण',
  'gate.dispute.record': 'दर्ज करें',
  'gate.dispute.recheck': 'दोबारा जाँच',
  'gate.dispute.firstValue': 'पहला नाप',
  'gate.dispute.newWeight': 'नया वज़न (किलो)',
  'gate.dispute.sameBag': 'वही बोरी, वही तराज़ू, किसान के सामने।',
  'gate.dispute.testWeight': 'टेस्ट बाट रीडिंग ({kg})',
  'gate.dispute.testWeightHint': 'सिर्फ़ जब वे कहें कि तराज़ू गलत है।',
  'gate.dispute.testOff': 'तराज़ू 0.1 किलो से ज़्यादा गलत: तौलना रोकें, सुपरवाइज़र को बुलाएँ।',
  'gate.dispute.gradeHint': 'उनके साथ बोरी को लाल रेखा कार्ड से मिलाएँ और नई फोटो लें।',
  'gate.dispute.photo': 'फ़ोटो',
  'gate.dispute.farmerPicked': 'किसान ने बोरी चुनी',
  'gate.dispute.outcome': 'नतीजा',
  'gate.dispute.allValues': 'सभी नाप',
  'gate.dispute.nowCounts': 'अब यह गिना जाएगा',
  'gate.dispute.money': 'पैसे पर असर',
  'gate.dispute.callStands': 'लाल रेखा का फ़ैसला वही',
  'gate.dispute.redTieStays': 'लाल टाई लगी रहेगी: गेट पर फ़ैसला कभी नहीं पलटता।',
  'gate.dispute.settled': 'निपटा',
  'gate.dispute.bagHome': 'बोरी घर जाएगी',
  'gate.dispute.closeHeld': 'भुगतान रुका, जाँच बाद में',

  'gate.list.title': 'आज की डिलीवरी',
  'gate.list.hint': 'लॉट, रोक और भुगतान की स्थिति',
  'gate.list.day': 'दिन',
  'gate.list.empty': 'अभी कोई डिलीवरी नहीं।',
  'gate.list.inProgress': 'चल रही है',
  'gate.list.waiting': 'भेजना बाकी',
  'gate.list.sending': 'भेज रहे हैं',
  'gate.list.received': 'पहुँच गई',
  'gate.list.held': 'ऑफ़िस में रुकी',
  'gate.list.problem': 'ध्यान दें',
  'gate.list.onHold': 'रुका',
  'gate.list.disputed': 'असहमति',
  'gate.list.slip': 'पर्ची {no}',
  'gate.pay.waiting': 'इंतज़ार',
  'gate.pay.sent': 'बैंक को भेजा',
  'gate.pay.paid': 'भुगतान हुआ',
  'gate.pay.officeWillCall': 'ऑफ़िस फ़ोन करेगा',

  'gate.closeDay.draftOpen': 'पहले {name} की डिलीवरी पूरी या रद्द करें।',
  'gate.closeDay.lotsToday': 'आज के लॉट',
  'gate.closeDay.lotsLine': '{lots} लॉट · {bags} {bags:बोरी|बोरियाँ} · {kg}',
  'gate.closeDay.tagCount': 'टैग का हिसाब',
  'gate.closeDay.sealCount': 'सील का हिसाब',
  'gate.closeDay.inHand': 'हाथ में',
  'gate.closeDay.plusOpened': '{n} नए खोले',
  'gate.closeDay.onBags': 'बोरी पर',
  'gate.closeDay.voided': 'रद्द',
  'gate.closeDay.shouldBeLeft': 'बचने चाहिए',
  'gate.closeDay.tagsCounted': 'बचे टैग (गिनकर)',
  'gate.closeDay.sealsCounted': 'बची सील (गिनकर)',
  'gate.closeDay.balanced': 'हिसाब मिल गया',
  'gate.closeDay.notBalanced': 'हिसाब नहीं मिला। दिन अपवाद के साथ बंद होगा; सुपरवाइज़र ठीक करेगा।',
  'gate.closeDay.recordsWaiting': 'भेजने बाकी रिकॉर्ड: {count}',
  'gate.closeDay.photosWaiting': 'भेजनी बाकी फोटो: {count}',
  'gate.closeDay.close': 'दिन बंद करें',
  'gate.closeDay.closed': 'दिन बंद हुआ। सब रिकॉर्ड जाने तक फ़ोन नेटवर्क पर रखें।',
  'gate.closeDay.waitingServer': 'फ़ोन पर बंद। रिकॉर्ड ऑफ़िस पहुँचने का इंतज़ार।',
  'gate.closeDay.serverBalanced': 'ऑफ़िस में दिन का हिसाब मिल गया।',
  'gate.closeDay.serverUnbalanced': 'ऑफ़िस में दिन का हिसाब नहीं मिला।',
  'gate.closeDay.allSent': 'सब रिकॉर्ड भेज दिए। ऑफ़िस हिसाब मिलाएगा।',

  'gate.paper.title': 'कागज़ का दिन भरें',
  'gate.paper.hint': 'रसीद बुक की पर्चियाँ 24 घंटे में भरें',
  'gate.paper.short': 'कागज़ का दिन',
  'gate.paper.continue': 'कागज़ का दिन जारी रखें',
  'gate.paper.explain':
    'जहाँ बोरियाँ हैं, वहीं 24 घंटे में रसीद बुक से कागज़ का दिन भरें। हर लॉट सुपरवाइज़र की जाँच तक रुकेगा।',
  'gate.paper.cover': 'कवर पेज',
  'gate.paper.operator': 'कागज़ के दिन का ऑपरेटर',
  'gate.paper.book': 'रसीद बुक',
  'gate.paper.bookNo': 'किताब',
  'gate.paper.noBook': 'इस ऑपरेटर को कोई रसीद बुक नहीं दी गई।',
  'gate.paper.startTime': 'शुरू का समय',
  'gate.paper.endTime': 'ख़त्म का समय',
  'gate.paper.testRead': 'टेस्ट बाट ({kg}) पर तराज़ू ने दिखाया',
  'gate.paper.testOff': '0.1 किलो से ज़्यादा फ़र्क: दिन जाँच के लिए चिह्नित होगा।',
  'gate.paper.rollHint': 'अगर उस दिन रोल पक्का नहीं हुआ, उसका पहला और आख़िरी टैग स्कैन करें।',
  'gate.paper.open': 'भरना शुरू करें',
  'gate.paper.opened': 'कागज़ का दिन खुला',
  'gate.paper.typedSlips': '{n} भरी',
  'gate.paper.spoiledSlips': '{n} रद्द',
  'gate.paper.missing': 'छूटी पर्चियाँ: {slips}। भरें या रद्द चिह्नित करें।',
  'gate.paper.typeSlip': 'पर्ची भरें',
  'gate.paper.spoiled': 'पर्ची रद्द थी',
  'gate.paper.spoiledSaved': 'पर्ची {slip} रद्द चिह्नित',
  'gate.paper.close': 'दिन बंद',
  'gate.paper.slipTime': 'पर्ची पर समय',
  'gate.paper.pagePhoto': 'पन्ने की फ़ोटो',
  'gate.paper.notInBook': 'इस किताब में नहीं ({from}–{to})।',
  'gate.paper.slipUsed': 'यह पर्ची पहले भरी या रद्द हो चुकी।',
  'gate.paper.typingSlip': 'किताब {book} की पर्ची {slip}: सूची नंबर और नाम से किसान खोजें।',
  'gate.paper.slipEyebrow': 'कागज़ की पर्ची {slip}',
  'gate.paper.backToDay': 'कागज़ के दिन पर वापस',

  'gate.retag.title': 'रुकी बोरियों पर नया टैग',
  'gate.retag.hint': 'सुपरवाइज़र: बिना टैग रखी बोरी पर नया टैग',
  'gate.retag.supOnly': 'नया टैग सिर्फ़ सुपरवाइज़र लगा सकता है (उसका पिन पूछा जाएगा)।',
  'gate.retag.none': 'किसी को टैग का इंतज़ार नहीं।',
  'gate.retag.noneHint':
    'ऑफ़िस ने जिन बोरियों या नमूनों को बिना टैग रखा, वे सिंक के बाद यहाँ दिखेंगे।',
  'gate.retag.bag': 'बोरी',
  'gate.retag.sample': 'नमूना',
  'gate.retag.conflict': 'स्कैन किया कोड {code} पहले से किसी और बोरी पर था।',
  'gate.retag.scanTag': 'नया टैग स्कैन करें',
  'gate.retag.scanSeal': 'नई सील स्कैन करें',
  'gate.retag.supReason': 'इस रुकी बोरी या नमूने पर नया टैग लगाएँ।',
  'gate.retag.done': 'नया टैग {code} सेव हुआ',

  'gate.code.MOULD': 'फफूँद',
  'gate.code.SPROUTING': 'अंकुर',
  'gate.code.INSECT_DAMAGE': 'कीड़े का नुकसान',
  'gate.code.FOREIGN_MATTER': 'कचरा / मिलावट',
  'gate.code.CHEMICAL_SACK': 'दवा/खाद की पुरानी बोरी',
  'gate.code.OTHER': 'अन्य',
  'gate.code.TORN': 'फटा',
  'gate.code.MISPRINT': 'गलत छपा',
  'gate.code.LOOKS_WET': 'गीला दिखता है',
  'gate.code.WALK_AWAY': 'चले गए',
  'gate.code.WRONG_FARMER': 'ग़लत किसान',
  'gate.code.DUPLICATE': 'दो बार खुला',
  'gate.code.DIVERTED_TO_DRY': 'सुखाने घर ले गए',
  'gate.code.MOVED_TO_PAPER': 'कागज़ पर गया',
  'gate.code.TYPED_DIFFERS': 'लिखा वज़न तराज़ू से अलग',
  'gate.code.SCALE_NOT_SETTLED': 'तराज़ू रुका नहीं था',
  'gate.code.SCALE_WRONG': 'तराज़ू गलत है',
  'gate.code.DEFECT_NOT_THERE': 'ख़राबी नहीं है',
  'gate.code.WRONG_LINE': 'कार्ड की गलत रेखा',
  'gate.code.READING_TOO_HIGH': 'रीडिंग ज़्यादा',
  'gate.code.STORAGE_RISK': 'भंडारण का जवाब',
  'gate.code.OVER_ESTIMATE': 'खेत के अनुमान से ज़्यादा',
  'gate.code.TAG_CONFLICT': 'टैग दो बोरियों पर',
  'gate.code.SAMPLE_MISSING': 'नमूना नहीं',
  'gate.code.MOISTURE_NOT_READ': 'नमी नहीं पढ़ी',
  'gate.code.BAG_COUNT_MISMATCH': 'बोरी की गिनती',
  'gate.code.PAPER_DAY': 'कागज़ का दिन',
  'gate.code.DEVICE_REVOKED': 'फ़ोन बंद किया गया',
  'gate.code.ORIGIN_MISMATCH': 'मूल की जाँच',
  'gate.code.OPEN_DISPUTE': 'खुली असहमति',
  'gate.crop.groundnut': 'मूँगफली',
  'gate.crop.moong': 'मूँग',
  'gate.crop.sesame': 'तिल',

  'gate.v1.when.today': 'आज {time}',
  'gate.v1.when.yesterday': 'कल {time}',
  'gate.v1.a11y.speakQuestion': 'सवाल सुनाएँ',
  'gate.v1.a11y.speak': 'बोलकर सुनाएँ',
  'gate.v1.a11y.farmerPhoto': 'किसान की फोटो',
  'gate.v1.a11y.registeredPhoto': 'रजिस्ट्रेशन वाली फोटो',
  'gate.v1.a11y.photo': 'फोटो',
  'gate.v1.a11y.pending': '{count} भेजना बाकी',
  'gate.v1.a11y.allSent': 'सब भेज दिया',
  'gate.v1.a11y.moreOptions': 'और विकल्प',
  'gate.v1.a11y.changeSack': 'बारदाना बदलें',
  'gate.v1.camera.torch': 'टॉर्च',
  'gate.v1.unit.kg': 'किलो',
  'gate.v1.spoken.kg': '{value} किलो',
  'gate.v1.spoken.percent': '{value} प्रतिशत',
  'gate.v1.help.photo1': 'फोटो: खुली बोरी और कार्ड',
  'gate.v1.help.photo2': 'फोटो: सैंपल निकालते हाथ',
  'gate.v1.help.photo3': 'फोटो: टैग बाँधते हाथ',
  'gate.v1.help.photo4': 'फोटो: काँटे का डिस्प्ले',
  'gate.v1.help': 'मदद',
  'gate.v1.more.weighHelp': 'बोरी तौलना और टैग लगाना',
  'gate.v1.update.a11y': 'ऐप वर्शन {version}। फ़ोन अपडेट करें',
  'gate.v1.update.title': 'फ़ोन अपडेट करें',
  'gate.v1.update.version': 'ऐप वर्शन {version}',
  'gate.v1.update.what':
    'बाकी काम भेजेगा, नई किसान सूची और सेटिंग लाएगा, और नया ऐप वर्शन हो तो लगा देगा।',
  'gate.v1.update.now': 'अभी अपडेट करें',
  'gate.v1.update.busy': 'अपडेट हो रहा है…',
  'gate.v1.update.done': 'फ़ोन अपडेट हो गया। ऐप नया वर्शन है।',
  'gate.v1.update.reloading': 'नया वर्शन मिला। ऐप फिर से खुल रहा है…',
  'gate.v1.update.offline': 'इंटरनेट नहीं है। जुड़ें और फिर अपडेट दबाएँ।',
  'gate.v1.update.signedOut': 'नई किसान सूची के लिए साइन इन करें।',
  'gate.v1.update.failed': 'अपडेट नहीं हुआ: {error}',
  'gate.v1.update.locked': 'पहले यह काम पूरा करें। फिर होम स्क्रीन से अपडेट करें।',
  'gate.v1.update.waiting': 'नया ऐप वर्शन तैयार है। होम से अपडेट करने पर लगेगा।',
  'gate.v1.update.demo': 'यह डेमो फ़ोन है। सर्वर से कुछ नहीं ला सकता।',
  'gate.v1.back': 'पीछे',
  'gate.v1.pending': '{count} भेजना बाकी',
  'gate.v1.allSent': 'सब भेज दिया',
  'gate.v1.farmerNo': 'नं. {no}',
  'gate.v1.farmerLine': 'नं. {no} · {crop}',
  'gate.v1.father': 'पिता: {name}',
  'gate.v1.kg': '{kg} किलो',
  'gate.v1.bags': '{count} बोरी',
  'gate.v1.next': 'आगे',
  'gate.v1.save': 'सेव करें',
  'gate.v1.change': 'बदलें',
  'gate.v1.fix': 'ठीक करें',
  'gate.v1.why': 'क्यों?',
  'gate.v1.pickReason': 'कारण चुनें',
  'gate.v1.listen': 'सुनें',
  'gate.v1.answer.NO': 'नहीं',
  'gate.v1.answer.DONT_KNOW': 'पता नहीं',
  'gate.v1.answer.YES': 'हाँ',
  'gate.v1.grade.good': 'अच्छी',
  'gate.v1.grade.red': 'लाल टाई',
  'gate.v1.lot.good': 'अच्छा',
  'gate.v1.lot.red': 'लाल टाई',
  'gate.v1.perKg': '{price} किलो',
  'gate.v1.saveFailed': 'सेव नहीं हुआ',
  'gate.v1.confirm.takePhoto': 'किसान की फ़ोटो लें',
  'gate.v1.confirm.retakePhoto': 'फ़ोटो फिर से लें',
  'gate.v1.confirm.noPhoto': 'फ़ोटो नहीं है · चाहें तो लें',
  'gate.v1.find.title': 'किसान खोजें',
  'gate.v1.bank.title': 'बैंक खाता',
  'gate.v1.village.title': 'आज कौन सा गाँव?',
  'gate.v1.village.line':
    '{name}, आप एक से ज़्यादा गाँव में काम करते हैं। जिस गाँव में अभी हैं, वह चुनें।',
  'gate.v1.village.tap': 'गाँव पर दबाएँ',
  'gate.v1.village.current': 'यह फ़ोन अभी इसी गाँव का है',
  'gate.v1.village.switch': 'फ़ोन को इस गाँव पर करें',
  'gate.v1.village.loading': 'किसान सूची आ रही है…',
  'gate.v1.village.needNet': 'गाँव बदलने पर उसकी किसान सूची आती है: इंटरनेट चाहिए।',
  'gate.v1.village.closeFirst':
    'इस फ़ोन पर {village} में दिन या खरीद अभी खुली है। पहले उसे पूरा करके दिन बंद करें, फिर गाँव बदलें।',
  'gate.v1.village.change': 'गाँव बदलें',
  'gate.v1.bank.replaceChecked':
    '{name} का खाता ••••{last4} पहले से जुड़ा और जाँचा हुआ है। नया खाता सिर्फ़ बदलने के लिए जोड़ें: ऑफ़िस की मंज़ूरी के बाद यह ••••{last4} की जगह लेगा। तब तक पैसा ••••{last4} में ही जाएगा।',
  'gate.v1.bank.replacePending':
    '{name} का खाता ••••{last4} पहले से जुड़ा है और ऑफ़िस की मंज़ूरी बाकी है। नया तभी जोड़ें जब ••••{last4} गलत हो।',
  'gate.v1.bank.replaceQueued':
    '{name} का खाता ••••{last4} इस फ़ोन में सहेजा है, नेटवर्क आने पर जाँच होगी। नया तभी जोड़ें जब ••••{last4} गलत हो।',
  'gate.v1.bank.offlineQueue':
    'नेटवर्क नहीं है: खाता नंबर इस फ़ोन में सुरक्षित सहेजा जा सकता है; नेटवर्क आने पर OnGrid से जाँच होगी।',
  'gate.v1.bank.numberLineOffline':
    'पासबुक से। अभी फ़ोन में सहेजें, नेटवर्क आने पर OnGrid से जाँच होगी।',
  'gate.v1.bank.saveQueued': 'फ़ोन में सहेजें · नेटवर्क पर जाँच',
  'gate.v1.bank.queuedAccount': 'खाता ••••{last4} · फ़ोन में सहेजा',
  'gate.v1.bank.queuedLine':
    'नेटवर्क आने पर OnGrid इसकी जाँच करेगा; फिर ऑफ़िस मंज़ूर करेगा। जाँच विफल हुई तो ऑफ़िस फ़ोन करेगा।',
  'gate.v1.bank.hasQueued': 'खाता ••••{last4} · फ़ोन में सहेजा, जाँच बाकी',
  'gate.v1.bank.why':
    '{name} का पैसा उनके अपने बैंक खाते में जाता है। अभी खाता जोड़ें: एक मिनट लगेगा।',
  'gate.v1.bank.offline':
    'नेटवर्क नहीं है: बैंक जाँच के लिए इंटरनेट चाहिए। बाद में होम · खाते की जानकारी से करें।',
  'gate.v1.bank.upi': 'UPI · ₹1 भेजें',
  'gate.v1.bank.upiLine': 'अपने UPI ऐप से (PhonePe, GPay, Paytm…)। बैंक उनका खाता बताएगा।',
  'gate.v1.bank.number': 'खाता नंबर',
  'gate.v1.bank.numberLine': 'पासबुक से। OnGrid खाता और IFSC जाँचेगा।',
  'gate.v1.bank.accountNo': 'खाता नंबर',
  'gate.v1.bank.accountNoAgain': 'खाता नंबर फिर से',
  'gate.v1.bank.notSame': 'दोनों नंबर एक जैसे नहीं हैं',
  'gate.v1.bank.ifsc': 'IFSC (पासबुक पर)',
  'gate.v1.bank.ifscBad': 'IFSC 11 अक्षर-अंक का होता है, जैसे SBIN0001234',
  'gate.v1.bank.nameOnPassbook': 'पासबुक पर नाम',
  'gate.v1.bank.numberNotKept':
    'जाँचा हुआ पूरा नंबर सर्वर पर एन्क्रिप्ट रहता है। स्क्रीन पर सिर्फ़ आख़िरी 4 अंक दिखते हैं।',
  'gate.v1.bank.consent': 'किसान सहमत हैं कि OnGrid से इन बैंक विवरणों की जाँच की जाए।',
  'gate.v1.bank.verify': 'खाता जाँचें और सहेजें',
  'gate.v1.bank.send1': 'जाँच के लिए ₹1 भेजें',
  'gate.v1.bank.fillAll': 'नंबर दो बार, IFSC लिखें और सहमति दें',
  'gate.v1.bank.upiAsk': '{name} अपने UPI ऐप से यह स्कैन करें और अपने खाते से ₹1 भेजें।',
  'gate.v1.bank.upiAskLink':
    'यह UPI लिंक {name} के फ़ोन पर भेजें। वे इसे खोलकर अपने खाते से ₹1 भेजें — इस फ़ोन से नहीं।',
  'gate.v1.bank.shareLink': 'उनके फ़ोन पर लिंक भेजें',
  'gate.v1.bank.qr': '₹1 भेजने का UPI QR',
  'gate.v1.bank.openUpi': 'UPI ऐप में खोलें',
  'gate.v1.bank.waitingUpi': 'उनके ₹1 का इंतज़ार…',
  'gate.v1.bank.waitingBank': 'बैंक खाता जाँच रहा है…',
  'gate.v1.bank.failedBank': 'OnGrid इस खाते की पुष्टि नहीं कर सका। खाता नंबर और IFSC जाँचें।',
  'gate.v1.bank.doneAccount': 'खाता ••••{last4} · सत्यापित',
  'gate.v1.bank.onGridResult': 'OnGrid परिणाम: {status}',
  'gate.v1.bank.nameAtBank': 'बैंक में नाम: {name}',
  'gate.v1.bank.nameNotReturned': 'OnGrid ने खाताधारक का नाम नहीं दिया।',
  'gate.v1.bank.bankName': 'बैंक: {bank}',
  'gate.v1.bank.confirmResult':
    'किसान को ये OnGrid विवरण दिखाकर नाम, बैंक, IFSC और आख़िरी 4 अंक पक्का करें।',
  'gate.v1.bank.officeApproves': 'ऑफ़िस इसे मंज़ूर करेगा, फिर उनका पैसा इसी खाते में जाएगा।',
  'gate.v1.bank.tryAgain': 'फिर से कोशिश करें',
  'gate.v1.bank.later': 'अभी नहीं · पैसा रुकेगा',
  'gate.v1.slip.queuedAccount': 'खाता ••••{last4} · सहेजा गया, नेटवर्क आने पर जाँच',
  'gate.v1.slip.pendingAccount': 'खाता ••••{last4} · ऑफ़िस मंज़ूर कर रहा है',
  'gate.v1.home.collectBank': 'खाते की जानकारी',
  'gate.v1.home.collectBankLine': 'बैंक खाता',
  'gate.v1.bank.pick': 'किसका बैंक खाता?',
  'gate.v1.bank.hasVerified': 'खाता ••••{last4} · जाँचा गया',
  'gate.v1.bank.hasPending': 'खाता ••••{last4} · मंज़ूरी बाकी',
  'gate.v1.bank.hasNone': 'बैंक खाता नहीं है',
  'gate.v1.bank.addAnother': 'दूसरा खाता जोड़ें',
  'gate.v1.bank.saved': 'सहेजा गया। अब ऑफ़िस मंज़ूर करेगा।',
  'gate.v1.find.rosterNo': 'किसान आईडी नंबर (जैसे U001 → 1)',
  'gate.v1.find.found': 'मिला',
  'gate.v1.find.none': 'इस नाम का कोई किसान नहीं। नाम ठीक से लिखें, या पिता के नाम से खोजें।',
  'gate.v1.find.byName': 'नाम से खोजें',
  'gate.v1.find.name': 'नाम, पिता का नाम या किसान आईडी',
  'gate.v1.find.clear': 'मिटाएँ',
  'gate.v1.find.tapName': 'किसान के नाम पर दबाएँ',
  'gate.v1.find.matches': '{n} मिले',
  'gate.v1.find.inVillage': '{village} में {n} किसान',
  'gate.v1.find.showAll': 'सब दिखाएँ ({n} और)',
  'gate.v1.find.notListed': 'सूची में नहीं',
  'gate.v1.find.notListedBody': 'सूची में नहीं हैं तो आज नहीं ख़रीद सकते। सुपरवाइज़र को बताएँ।',
  'gate.v1.find.cta': 'यही किसान',
  'gate.v1.find.typeNo': 'सूची नंबर लिखें',
  'gate.v1.confirm.title': 'क्या यही हैं?',
  'gate.v1.confirm.face': 'चेहरा मिलाएँ',
  'gate.v1.confirm.no': 'नहीं, ये नहीं',
  'gate.v1.confirm.yes': 'हाँ, यही हैं',
  'gate.v1.crop.acre': 'एकड़',
  'gate.v1.crop.hectare': 'हेक्टेयर',
  'gate.v1.crop.sown': 'बुवाई {date}',
  'gate.v1.crop.title': 'खेत और फ़सल चुनें',
  'gate.v1.crop.twoCrops': 'दो खेत हों तो हर खेत की अलग ख़रीद',
  'gate.v1.crop.none':
    'इनकी कोई फ़सल कटाई के लिए तैयार नहीं है। आज ख़रीद नहीं होगी — सुपरवाइज़र को फ़ोन करें',
  'gate.v1.storage.title': '2 सवाल',
  'gate.v1.storage.q1': 'घर पर हफ़्ते से ज़्यादा रखा?',
  'gate.v1.storage.q2': 'कोई दवाई डाली?',
  'gate.v1.storage.q2hint': 'सल्फ़ास, गोली, पाउडर · नीम/राख = नहीं',
  'gate.v1.storage.left': '{count} जवाब बाकी',
  'gate.v1.storage.q1short': 'घर पर हफ़्ते से ज़्यादा',
  'gate.v1.storage.q2short': 'दवाई डाली',
  'gate.v1.dry.button': 'घर पर सुखाएँगे',
  'gate.v1.dry.title': 'घर पर सुखाएँगे',
  'gate.v1.dry.later': 'बाद में लाएँ',
  'gate.v1.dry.price': 'उस दिन के भाव पर',
  'gate.v1.dry.card': '**सुखाने का कार्ड** दें',
  'gate.v1.dry.bags': 'बोरियाँ **बिना टैग** लौटाएँ',
  'gate.v1.dry.sellToday': 'आज बेचेंगे',
  'gate.v1.dry.confirm': 'पक्का करें',
  'gate.v1.moisture.title': 'नमी',
  'gate.v1.moisture.meterSet': 'मीटर पर फ़सल **{crop}** चुनी हो',
  'gate.v1.moisture.anyBag': 'किसी एक अच्छी बोरी से',
  'gate.v1.moisture.noMeter': 'आज मीटर नहीं',
  'gate.v1.moisture.noMeterSaved': 'आज मीटर नहीं · ऑफ़िस को पता चलेगा',
  'gate.v1.moisture.range': '{min}% से {max}% के बीच लिखें',
  'gate.v1.moisture.type': 'नमी लिखें',
  'gate.v1.tag.title': 'टैग लगाएँ',
  'gate.v1.tag.sub': 'बोरी {n} का टैग',
  'gate.v1.tag.lastSaved': 'बोरी {n} सेव · {kg} किलो',
  'gate.v1.tag.hold': 'टैग सामने रखें',
  'gate.v1.tag.type': 'नंबर लिखें',
  'gate.v1.tag.typeTitle': 'टैग नंबर लिखें',
  'gate.v1.tag.fixLast': 'पिछली ठीक',
  'gate.v1.tag.allDone': 'सब बोरी हो गईं',
  'gate.v1.tag.noneYet': 'पहली बोरी का टैग',
  'gate.v1.tag.camera': 'कैमरा नहीं खुला · नंबर लिखें',
  'gate.v1.tag.voidTag': 'टैग ख़राब',
  'gate.v1.weigh.title': 'तौल लिखें',
  'gate.v1.weigh.paperSub': 'पर्ची से तौल',
  'gate.v1.weigh.bandGood': 'अच्छी · {count} बोरी · {kg} किलो',
  'gate.v1.weigh.bandRed': 'लाल टाई · {count} बोरी · {kg} किलो',
  'gate.v1.weigh.tag': 'टैग {code}',
  'gate.v1.weigh.weightOf': 'बोरी {n} का वज़न (बोरी समेत)',
  'gate.v1.weigh.paperWeight': 'पर्ची पर लिखा वज़न',
  'gate.v1.weigh.net': 'माल',
  'gate.v1.weigh.scalePhoto': 'तराज़ू की फ़ोटो',
  'gate.v1.weigh.scalePhotoTaken': 'तराज़ू की फ़ोटो ली गई',
  'gate.v1.weigh.scalePhotoRetake': 'तराज़ू की फ़ोटो फिर से लें',
  'gate.v1.weigh.optional': 'चाहें तो',
  'gate.v1.moisture.photo': 'मीटर की फ़ोटो',
  'gate.v1.moisture.photoTaken': 'मीटर की फ़ोटो ली गई',
  'gate.v1.moisture.photoRetake': 'मीटर की फ़ोटो फिर से लें',
  'gate.v1.weigh.saveGood': 'नमूना डाला · सेव',
  'gate.v1.weigh.saveRed': 'लाल टाई बाँधी · सेव',
  'gate.v1.weigh.savePaper': 'सेव, अगली बोरी',
  'gate.v1.weigh.pickGrade': 'अच्छी या लाल टाई?',
  'gate.v1.weigh.pickSack': 'बारदाना चुनें',
  'gate.v1.weigh.typeWeight': 'वज़न लिखें',
  'gate.v1.weigh.notMoreThanSack': 'वज़न बारदाने से ज़्यादा हो',
  'gate.v1.weigh.again': '{min}–{max} किलो से बाहर · फिर से लिखें',
  'gate.v1.weigh.sackTitle': 'बारदाना',
  'gate.v1.weigh.sackLine': '{kg} किलो',
  'gate.v1.weigh.sackLetter': 'बारदाना {letter}',
  'gate.v1.weigh.seePage': 'पन्ना देखें',
  'gate.v1.fix.title': 'पिछली बोरी ठीक करें?',
  'gate.v1.fix.bag': 'बोरी {n} · टैग {code}',
  'gate.v1.fix.was': 'लिखा था',
  'gate.v1.fix.typo': 'ग़लत टाइप',
  'gate.v1.fix.reweighed': 'दोबारा तौला',
  'gate.v1.fix.warn': 'सेव के बाद **बदल नहीं सकते**',
  'gate.v1.fix.newWeight': 'नया वज़न (बोरी समेत)',
  'gate.v1.help.weighTitle': 'तौल: कैसे करें',
  'gate.v1.help.step1': 'बोरी खोलें, कार्ड से मिलाएँ',
  'gate.v1.help.step2': 'अच्छी: नमूना निकालें · फेल: लाल टाई',
  'gate.v1.help.step3': 'टैग बाँधें, स्कैन करें',
  'gate.v1.help.step4': 'नंबर रुकने दें, वही लिखें',
  'gate.v1.help.trouble': 'गड़बड़ हो तो',
  'gate.v1.help.tip1': 'स्कैन नहीं हो रहा → **नंबर लिखें**',
  'gate.v1.help.tip2': 'ग़लत वज़न सेव → **पिछली ठीक**',
  'gate.v1.help.tip3': 'अपनी बोरी → **बारदाना** बदलें',
  'gate.v1.help.gotIt': 'समझ आ गया',
  'gate.v1.help.generalTitle': 'मदद',
  'gate.v1.help.general': 'कुछ समझ न आए तो सुपरवाइज़र को फ़ोन करें। जो सेव हुआ, वह फ़ोन पर रहेगा।',
  'gate.v1.pin.who': 'कौन काम कर रहा है?',
  'gate.v1.pin.whoSub': 'अपना नाम चुनें',
  'gate.v1.pin.title': 'पिन डालें',
  'gate.v1.pin.sub': 'पिन डालें',
  'gate.v1.pin.press': 'अपना {n} अंक का पिन दबाएँ',
  'gate.v1.pin.dots': '{n} में से {done} अंक दबाए',
  'gate.v1.pin.forgot': 'पिन भूल गए',
  'gate.v1.pin.forgotText':
    'सुपरवाइज़र से कहें। वे ऑफ़िस से नया पिन बनाएँगे; अगली सूची के साथ यह फ़ोन पर आ जाएगा।',
  'gate.v1.pin.open': 'खोलें',
  'gate.v1.pin.role.village_operator': 'ख़रीद की ऑपरेटर',
  'gate.v1.pin.role.supervisor': 'सुपरवाइज़र',
  'gate.v1.seal.title': 'नमूना सील करें',
  'gate.v1.seal.inFront': '**किसान के सामने** थैली बंद करें',
  'gate.v1.seal.hold': 'सील सामने रखें',
  'gate.v1.seal.code': 'सील {code}',
  'gate.v1.seal.scanned': 'स्कैन हुई',
  'gate.v1.seal.save': 'सेव, डिब्बे में रखें',
  'gate.v1.refuse.unknown': 'इस गाँव के रोल का नहीं। अलग रखें, अगला लें।',
  'gate.v1.refuse.otherFarmer': 'यह {name} की बोरी का है। होम से {name} खोलें।',
  'gate.v1.seal.typeTitle': 'सील नंबर लिखें',
  'gate.v1.slip.title': 'आपका हिसाब',
  'gate.v1.slip.handBack': 'फ़ोन वापस लें',
  'gate.v1.slip.value': 'माल की कीमत',
  'gate.v1.slip.account': 'खाता ••••{last4} · जाँचा हुआ',
  'gate.v1.slip.isYours': 'आपका है?',
  'gate.v1.slip.noAccount': 'बैंक खाता जाँचा नहीं · ऑफ़िस फ़ोन करेगा',
  'gate.v1.slip.parts': 'पैसा **{count} बार में**',
  'gate.v1.slip.bank': 'बैंक में भेजेंगे · एसएमएस आएगा',
  'gate.v1.slip.otp': 'ओटीपी किसी को न दें',
  'gate.v1.slip.goodLot': 'अच्छा माल · {count} बोरी',
  'gate.v1.slip.redLot': 'लाल टाई · {count} बोरी',
  'gate.v1.slip.show': 'देखें',
  'gate.v1.slip.hide': 'छिपाएँ',
  'gate.v1.slip.bagLine': 'टैग {tag}',
  'gate.v1.slip.lot': 'लॉट {code}',
  'gate.v1.slip.sack': 'बारदाना',
  'gate.v1.slip.less': '{kg} किलो कम',
  'gate.v1.slip.net': 'माल का वज़न',
  'gate.v1.slip.price': 'भाव',
  'gate.v1.slip.priceLine': '{kg} किलो ({q} क्विंटल)',
  'gate.v1.slip.amount': 'रकम',
  'gate.v1.slip.agrees': 'किसान ने माना',
  'gate.v1.paperSlip.title': 'पर्ची लिखें',
  'gate.v1.paperSlip.number': 'छपा नंबर {no}',
  'gate.v1.paperSlip.typeNo': 'छपा नंबर लिखें',
  'gate.v1.paperSlip.used': 'यह नंबर आज लिख चुके',
  'gate.v1.paperSlip.farmer': 'किसान',
  'gate.v1.paperSlip.bags': 'बोरी',
  'gate.v1.paperSlip.kg': 'किलो',
  'gate.v1.paperSlip.amount': 'रकम',
  'gate.v1.paperSlip.answers': '2 सवाल',
  'gate.v1.paperSlip.thumb': '2. नीचे वाली पर अँगूठा',
  'gate.v1.paperSlip.photoTaken': 'फोटो ली',
  'gate.v1.paperSlip.takePhoto': 'फोटो लें',
  'gate.v1.paperSlip.again': 'फिर से',
  'gate.v1.paperSlip.next': 'पर्ची दी, आगे',
  'gate.v1.final.title': 'आख़िरी जाँच',
  'gate.v1.final.missing': '{count} जाँच बाकी',
  'gate.v1.final.tags': 'टैग',
  'gate.v1.final.sealed': 'नमूना सील',
  'gate.v1.final.storage': '2 सवाल',
  'gate.v1.final.moisture': 'नमी',
  'gate.v1.final.cards': 'भाव',
  'gate.v1.final.slipNo': 'पर्ची नं.',
  'gate.v1.final.slipPhoto': 'पर्ची फोटो',
  'gate.v1.final.agreed': 'माना',
  'gate.v1.final.left': '{name} बाकी',
  'gate.v1.final.rows': '**अलग लाइन** · आगे **स्लेट**',
  'gate.v1.final.rowsLabel': 'हर लॉट अपनी अलग लाइन में, लाइन के आगे लॉट नंबर की स्लेट; ढेर पर नहीं',
  'gate.v1.final.close': 'ख़रीद पक्की करें',
  'gate.v1.final.more': 'और विकल्प',
  'gate.v1.confirm2.title': 'ख़रीद पक्की करें?',
  'gate.v1.confirm2.warn':
    'पक्की होने के बाद **बदल नहीं सकते**। ग़लती हो तो सुपरवाइज़र ठीक करेंगे।',
  'gate.v1.confirm2.yes': 'हाँ, पक्की',
  'gate.v1.done.title': 'ख़रीद पक्की',
  'gate.v1.done.value': 'माल की कीमत {amount}',
  'gate.v1.done.next': 'अगला किसान',
  'gate.v1.done.cancelled': 'ख़रीद रद्द',
  'gate.v1.done.nothingBought': 'कुछ नहीं ख़रीदा',
  'gate.v1.done.home': 'आज',
  'gate.v1.cancel.title': 'ख़रीद रद्द करें?',
  'gate.v1.cancel.nothing': 'कुछ नहीं ख़रीदा जाएगा',
  'gate.v1.cancel.cutTags': 'लगे हुए {count} टैग काट दें',
  'gate.v1.cancel.left': 'किसान चले गए',
  'gate.v1.cancel.dry': 'घर पर सुखाएँगे',
  'gate.v1.cancel.cutAndCancel': 'टैग काटे · रद्द करें',
  'gate.v1.cancel.cancelNow': 'रद्द करें',
  'gate.v1.open.title': 'दिन शुरू करें',
  'gate.v1.open.listFrom': 'सूची: {when}',
  'gate.v1.open.setupFirst': 'पहले लगाएँ',
  'gate.v1.open.scale': 'काँटा',
  'gate.v1.open.rateChart': 'भाव चार्ट',
  'gate.v1.open.redLine': 'लाल रेखा कार्ड',
  'gate.v1.open.roster': 'सूची',
  'gate.v1.open.rates': 'भाव · {crop}',
  'gate.v1.open.hasDeductions': 'कटौती वाला भाव: ऑफ़िस से पूछें',
  'gate.v1.open.cta': 'लगा दिया · दिन खोलें',
  'gate.v1.open.noRolls': 'इस गाँव को टैग रोल या सील पट्टी नहीं मिली। ऑफ़िस से पूछें।',
  'gate.v1.open.noCard': 'आज का भाव नहीं आया। ऑफ़िस से पूछें।',
  'gate.v1.open.listOld': 'सूची पुरानी है। नेटवर्क पर सूची लें।',
  'gate.v1.home.title': 'आज · {date}',
  'gate.v1.home.sub': 'आज',
  'gate.v1.home.dayOpen': 'दिन खुला',
  'gate.v1.home.dayOpenLine': '{village} · {time}',
  'gate.v1.home.dayClosed': 'आज दिन नहीं खुला',
  'gate.v1.home.battery': 'बैटरी {pct}% · जगह ठीक',
  'gate.v1.home.farmers': 'किसान',
  'gate.v1.home.bags': 'बोरी',
  'gate.v1.home.kg': 'किलो',
  'gate.v1.home.paper': 'काग़ज़ से भरें',
  'gate.v1.home.office': 'ऑफ़िस',
  'gate.v1.home.closeDay': 'दिन बंद',
  'gate.v1.home.deliveries': 'आज की ख़रीद',
  'gate.v1.home.nextFarmer': 'अगला किसान',
  'gate.v1.toHome': 'होम: यह किसान खुला रहेगा',
  'gate.v1.task.title': 'काम',
  'gate.v1.task.screen': 'यह ख़रीद',
  'gate.v1.task.forms': 'भंडारण के 2 सवाल',
  'gate.v1.task.moisture': 'नमी',
  'gate.v1.task.bags': 'बोरियाँ: टैग और वज़न',
  'gate.v1.task.seal': 'नमूना सील',
  'gate.v1.task.bank': 'बैंक खाता',
  'gate.v1.task.short.forms': 'सवाल',
  'gate.v1.task.short.moisture': 'नमी',
  'gate.v1.task.short.bags': 'बोरियाँ',
  'gate.v1.task.short.seal': 'सील',
  'gate.v1.task.short.bank': 'बैंक',
  'gate.v1.task.done': 'हो गया',
  'gate.v1.task.toDo': 'करना है',
  'gate.v1.task.optional': 'ज़रूरी नहीं',
  'gate.v1.task.weighLeft': 'हर बोरी तौलें',
  'gate.v1.task.sealNotNeeded': 'ज़रूरत नहीं: सब बोरियों पर लाल टाई',
  'gate.v1.task.showSlip': 'पर्ची दिखाएँ',
  'gate.v1.task.locked': 'पर्ची मान ली: अब बदलाव नहीं',
  'gate.v1.home.left': 'बाकी: {tasks}',
  'gate.v1.home.readySlip': 'पर्ची के लिए तैयार',
  'gate.v1.moisture.change': 'बदलें',
  'gate.v1.sack.other': '+ दूसरी बोरी',
  'gate.v1.sack.typed': 'गेट पर लिखी',
  'gate.v1.sack.otherLine': 'सूची में नहीं: नाम और वज़न लिखें',
  'gate.v1.sack.needList': 'इसके लिए किसान सूची फिर से लें (नेटवर्क पर)',
  'gate.v1.sack.otherTitle': 'दूसरी बोरी',
  'gate.v1.sack.name': 'बोरी का नाम',
  'gate.v1.sack.weight': 'ख़ाली बोरी का वज़न (ग्राम, न हो तो 0)',
  'gate.v1.sack.fill': 'नाम और वज़न लिखें',
  'gate.v1.sack.tooHeavy': 'ख़ाली बोरी ज़्यादा से ज़्यादा {g} ग्राम',
  'gate.v1.sack.waits': 'इस बोरी के वज़न को ऑफ़िस मंज़ूर करेगा, तब तक भुगतान रुकेगा।',
  'gate.v1.tag.seeAll': 'सब देखें',
  'gate.v1.tag.allTitle': 'सब बोरियाँ · {count}',
  'gate.v1.tag.tagNo': 'टैग',
  'gate.v1.tag.grossLine': 'तराज़ू पर {kg} किलो',
  'gate.v1.tag.withdrawn': '{count} बोरी विवाद में घर गई',
  'gate.v1.home.alreadyOpen': '{name} पहले से खुले हैं, वहीं से जारी',
  'gate.v1.home.deleteFarmer': '{name} हटाएँ',
  'gate.v1.delete.title': '{name} को हटाएँ?',
  'gate.v1.delete.voidCodes': 'टैग और सील रद्द होंगे। बोरियों से काट दें।',
  'gate.v1.delete.wrongFarmer': 'ग़लत किसान',
  'gate.v1.delete.duplicate': 'दो बार खुला',
  'gate.v1.delete.confirm': 'हटाएँ',
  'gate.v1.home.openDay': 'दिन शुरू करें',
  'gate.v1.closeDay.title': 'दिन बंद करें',
  'gate.v1.closeDay.lots': 'आज के लॉट',
  'gate.v1.closeDay.goodLots': 'अच्छा · {count} लॉट',
  'gate.v1.closeDay.redLots': 'लाल टाई · {count} लॉट',
  'gate.v1.closeDay.lotLine': '{bags} बोरी · {kg} किलो',
  'gate.v1.closeDay.toSend': 'भेजना बाकी',
  'gate.v1.closeDay.pending': '{count} रिकॉर्ड · {photos} फोटो',
  'gate.v1.closeDay.sendNow': 'अभी भेजें',
  'gate.v1.closeDay.keepNetwork': '**सब भेज दिया** तक नेटवर्क रखें',
  'gate.v1.closeDay.draftOpen': 'पहले {name} की ख़रीद पूरी करें',
  'gate.v1.closeDay.draftsOpen': 'पहले {count} खुले किसानों की ख़रीद पूरी करें',
  'gate.v1.closeDay.closed': 'दिन बंद',
  'gate.v1.closeDay.allSentDone': 'सब भेज दिया',
  'gate.v1.paper.title': 'काग़ज़ वाला दिन भरें',
  'gate.v1.paper.typist': 'ऑफ़िस · अपने पिन से',
  'gate.v1.paper.day': '**{village}** · {date} · 24 घंटे में',
  'gate.v1.paper.typed': '{count} पर्ची भर दीं',
  'gate.v1.paper.pagePhoto': 'पन्ने की फोटो',
  'gate.v1.paper.taken': 'ली',
  'gate.v1.paper.scanEach': 'हर बोरी का **टैग स्कैन** करें',
  'gate.v1.paper.typeSlip': 'पर्ची {no} भरें',
  'gate.v1.paper.slipNo': 'पर्ची नंबर',
  'gate.v1.paper.slipTime': 'पर्ची पर समय',
  'gate.v1.paper.pickDay': 'किस दिन की पर्चियाँ?',
  'gate.v1.paper.open': 'दिन खोलें',
  'gate.v1.paper.band': 'काग़ज़ · पर्ची {no}',
  'gate.v1.paper.close': 'काग़ज़ वाला दिन बंद करें',
  'gate.v1.home.load': 'गाड़ी में चढ़ाएँ',
  'gate.v1.home.loadLine': '{lots} लॉट · {bags} बोरी',
  'gate.v1.home.pay': 'पैसा आया?',
  'gate.v1.home.batteryLow': 'बैटरी {pct}% · जगह कम',
  'gate.v1.home.spaceOk': 'जगह ठीक',
  'gate.v1.home.spaceLow': 'जगह कम',
  'gate.v1.pay.title': 'पैसा आया?',
  'gate.v1.pay.search': 'सूची नं.',
  'gate.v1.pay.paid': 'पहुँचा',
  'gate.v1.pay.sent': 'बैंक को भेजा',
  'gate.v1.pay.waiting': 'ऑफ़िस जाँच के बाद',
  'gate.v1.pay.problem': 'ऑफ़िस फ़ोन करेगा',
  'gate.v1.pay.notSent': 'फ़ोन पर · भेजना बाकी',
  'gate.v1.pay.none': 'कोई ख़रीद नहीं',
  'gate.v1.pay.home': 'आज',
  'gate.v1.sync.failed': 'भेजा नहीं जा सका · नेटवर्क देखें',
  'gate.v1.sync.last': 'आख़िरी बार भेजा: {when}',
  'gate.v1.sync.offlineOk': 'फ़ोन पर सब सुरक्षित है। नेटवर्क आते ही अपने-आप जाएगा।',
  'gate.v1.camera.denied': 'कैमरे की अनुमति बंद है · ब्राउज़र में कैमरा चालू करें',
  'gate.v1.camera.none': 'कैमरा नहीं मिला · नंबर लिखें',
  'gate.v1.camera.insecure': 'कैमरा सिर्फ़ सुरक्षित (एचटीटीपीएस) पते पर चलता है',
  'gate.v1.camera.retry': 'फिर से कोशिश',
  'gate.v1.photo.title': 'फोटो लें',
  'gate.v1.photo.shoot': 'फोटो खींचें',
  'gate.v1.photo.gallery': 'फ़ोन से चुनें',
  'gate.v1.photo.saving': 'फोटो सेव हो रही है',
  'gate.check.bagsTagged': 'टैग और वज़न ({count} बोरी)',
  'gate.check.sealed': 'नमूना सील',
  'gate.check.location': 'ख़रीद की लोकेशन',
  'gate.v1.gps.capture': 'लोकेशन लें',
  'gate.v1.gps.recapture': 'फिर से लें',
  'gate.v1.gps.locating': 'GPS ढूँढ रहे हैं…',
  'gate.v1.gps.holdStill': '±{m} मीटर — फ़ोन स्थिर रखें…',
  'gate.v1.gps.notYet': 'अभी नहीं ली। ख़रीद पक्की करने के लिए ज़रूरी है।',
  'gate.v1.gps.fallback': 'यहाँ GPS कमज़ोर है: पिछली सही लोकेशन ली गई (±{m} मीटर)।',
  'gate.v1.gps.denied':
    'लोकेशन बंद है। फ़ोन की सेटिंग में इस ऐप को लोकेशन की अनुमति दें, फिर "लोकेशन लें" दबाएँ।',
  'gate.v1.gps.noFix': 'GPS नहीं मिला। खुले आसमान के नीचे जाकर "लोकेशन लें" दबाएँ।',
  'gate.v1.gps.skip': 'बिना लोकेशन पक्की करें (सुपरवाइज़र)',
  'gate.v1.gps.skipped': 'सुपरवाइज़र ने बिना लोकेशन की अनुमति दी',
  'gate.v1.gps.supReason': 'बिना लोकेशन ख़रीद पक्की करना',
  'gate.check.cards': 'हर लॉट का भाव',
}
